export default "<h3>October 6, 2018</h3>\r\n<p>Update 0.34 fixes bugs and makes balancing changes.</p>";